WiseMetering.Views.IntegrationRawData = WiseMetering.Views.TableIndex.extend({
    template: 'templates/integrations/raw_data',

    ui: {
        to: '#date_time_to',
        from: '#date_time_from'
    },

    createTable: function() {
        this.showLoader();

        const
            from = this.ui.from.val(),
            to = this.ui.to.val();

        this.model.getRawData(
            from,
            to
        ).done(data => {
            const collection = new WiseMetering.Collection(data);

            this.table = new WiseMetering.Views.Table({
                disableSelect: true,
                id: 'integration-raw-data',
                collection,
                modelSerializer: model => {
                    return {
                        date: WiseMetering.utils.formatDate(model.get('t')),
                        value: model.get('v')
                    };
                },
                columns: {
                    date: i18next.t('common.date'),
                    value: i18next.t('common.value')
                },
                toolbar_actions: {
                    exportData: {
                        icon: 'csv',
                        label: i18next.t('ui.actions.export'),
                        view_call: () => window.open(`${process.env.API_URL}${this.model.url()}/raw_data.csv?from=${from}&to=${to}`)
                    }
                }
            });

            $(this.body.el).find('div#integration-raw-data-table').html(this.table.el);
        });
    },

    onShow: function() {
        const
            from = moment().subtract(1, 'months').format('YYYY-MM-DD'),
            to = moment().format('YYYY-MM-DD');

        this.ui.from.val(from);
        this.ui.to.val(to);

        $(this.body.el).find('#submit_time').click(() => {
            this.updateFields();
            if (this.ui.from.val() && this.ui.to.val()) {
                this.createTable();
            }
        });

        this.ui.from.datepicker({
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
            changeYear: true,
            showOtherMonths: true,
            onSelect: selectedFrom => {
                this.ui.to.datepicker('option', 'minDate', selectedFrom);
            }
        });

        this.ui.to.datepicker({
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
            changeYear: true,
            showOtherMonths: true,
            onSelect: selectedTo => {
                this.ui.from.datepicker('option', 'maxDate', selectedTo);
            }
        });

        this.createTable();
    },

    showLoader: function() {
        const loader = '<img class="componentLoading" src="/images/wisemetering/loader.svg" style="margin: 0 auto; max-height: 50px; width: 100%;">';
        $(this.body.el).find('div#integration-raw-data-table').html(loader);
    },

    updateFields: function() {
        this.ui.from.datepicker('option', 'maxDate', this.ui.to.val());
        this.ui.to.datepicker('option', 'minDate', this.ui.from.val());
    }
});
